<template>
    <v-btn id="show-matches-button"
        v-if="!isGuest"
           @click="onClick"
           content="Matches"
           v-tippy="{placement: 'left'}"
           :class="{'animation-flash': addingMatchAnimation}"
    >
        <i class="material-symbols-outlined">art_track</i>
        <MatchCounter />
    </v-btn>
</template>

<script>
import MatchCounter from "@/components/app/matches/MatchCounter.vue";
import CanMixin from "@/mixins/CanMixin";
import { mapGetters, mapState } from "vuex";

export default {
    components: {MatchCounter},
    mixins: [CanMixin],
    computed: {
        ...mapGetters('User', ['isGuest']),
        ...mapState("UI", ['addingMatchAnimation']),
    },
    methods: {
        onClick() {
            this.$store.dispatch('UI/setRightColumn', 'matches')
        },
    },
};
</script>

<style lang="scss" scoped>
#show-matches-button {
    overflow: visible;
    &.animation-flash {
        animation: button-flash 1s infinite ease-in-out;
    }
}
</style>
